import React from 'react';
import { useSelector } from 'react-redux';
import { selectTranslations } from '../App/slice/selectors';
import Images from 'app/assets/img';
const LoadingComponent = () => {
  const translations = useSelector(selectTranslations);
  return (
    <div
      style={{
        padding: 80,
        textAlign: 'center',
        width: '100%',
      }}
    >
      <img
        src={Images.loadingCombo}
        alt=""
        style={{ height: 150, width: 150, objectFit: 'fill' }}
      />
      <div
        style={{
          marginTop: 20,
          fontSize: 14,
          color: '#8D8D8D',
        }}
      >
        {translations?.['b2b.txt.loadingResults'] ?? ''}
      </div>
    </div>
  );
};
export default LoadingComponent;
